const getAncestors = (pathContext, allSitePage) => {
  const ancestorsArray = [];
  const trux = getParent(pathContext, allSitePage, ancestorsArray);
  return ancestorsArray.reverse();
}

const getParent = (pathContext, allSitePage, ancestorsArray = []) => {
  const parent = allSitePage.edges.find(item => {
    return  item.node.context.index == pathContext.parent;
  });

  if (parent) {
    ancestorsArray.push(parent);
    if (parent.node.context.parent.length > 0) {
      getParent(parent.node.context, allSitePage, ancestorsArray);
    } else {
      return ancestorsArray;
    }
  } else {
    return ancestorsArray;
  }

}


export default getAncestors;


// WEBPACK FOOTER //
// ./src/scripts/getAncestors.js